module.exports = __webpack_public_path__ + "img/profitability1.fb977440.png";